import { StudioApiError, type BillingGateReason } from "@/types/api";
import {
  PLAN_ERR_REDOWNLOAD,
  PLAN_ERR_SUBSCRIBE_ON_PLANS,
  PLAN_ERR_SUBSCRIBE_OR_UPGRADE,
  PLAN_ERR_UPGRADE_ON_PLANS,
} from "@/features/billing/planCopy";

export function isBillingAccessDenied(error: unknown): boolean {
  if (!(error instanceof StudioApiError)) {
    return false;
  }
  if (error.code !== "ACCESS_DENIED") {
    return false;
  }
  if (error.billingReason) {
    return true;
  }
  const msg = error.message.toLowerCase();
  return (
    msg.includes("subscribe") ||
    msg.includes("trial ended") ||
    msg.includes("subscription inactive") ||
    msg.includes("upgrade to pro") ||
    msg.includes("download not allowed")
  );
}

export function billingGateReasonFromError(
  error: unknown,
): BillingGateReason | undefined {
  if (error instanceof StudioApiError) {
    return error.billingReason;
  }
  return undefined;
}

export function billingAccessDeniedMessage(error: StudioApiError): string {
  if (error.billingReason === "upgrade_to_pro_required") {
    return PLAN_ERR_UPGRADE_ON_PLANS;
  }
  if (error.billingReason === "subscription_required") {
    return PLAN_ERR_SUBSCRIBE_ON_PLANS;
  }
  const msg = error.message.toLowerCase();
  if (msg.includes("upgrade to pro")) {
    return PLAN_ERR_UPGRADE_ON_PLANS;
  }
  if (msg.includes("download not allowed")) {
    return PLAN_ERR_REDOWNLOAD;
  }
  return PLAN_ERR_SUBSCRIBE_OR_UPGRADE;
}
